import React, { useState } from "react";
import * as emailjs from "emailjs-com";
import Alert from "react-bootstrap/Alert";
import "./style.css";
import VideoCustom from "../Video";
import ProgressCrowdfund from "../ProgressCrowdfund";

const CrowdfundingDescription = ({ description }) => {
  return (
    <section className="crowdfunding-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-xs-12">
            <div className="content clearfix">
              <div className="error-message">
                <VideoCustom
                  srcVideo={"crowdfounding-dez-2025"}
                  srcPoster={"crowdfounding-dez-2025-poster"}
                />
                <br />
                <br />
                <p className="text-align-center">
                  <b>O nosso crowdfunding terminou!</b>
                </p>
                <ProgressCrowdfund raised={1193} goal={7000} currency="EUR" />
                <br />
                <p className="text-align-center">
                  Obrigada por acompanhares, por fazeres parte e por teres
                  ajudado a Imani a chegar a mais pessoas.
                </p>
                <br />
                <p className="text-align-center">
                  Todo o apoio, seja na contribuição ou na partilha, ajuda-nos a
                  CRESCER, e desta forma podermos ter mais e melhor ESTRUTURA,
                  para podermos alcançar um maior número de CRIANÇAS e JOVENS
                  VULNERÁVEIS a terem a oportunidade de frequentar a ESCOLA,
                  terem APOIO, FORMAÇÃO e acesso ao ENSINO SUPERIOR, para
                  poderem seguir os seus SONHOS e terem um FUTURO melhor.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CrowdfundingDescription;
